import i18n from "i18n";

const headers = {
  image: {
    name: 'image',
    title: '',
    active: false,
    direction: false,
  },
  name: {
    name: 'name',
    title: i18n.t("name").toUpperCase(),
    active: false,
    direction: false,
    value: 'name',
  },
  document: {
    name: 'document',
    title: i18n.t("document").toUpperCase(),
    active: false,
    direction: false,
    value: 'document',
  },
  sector: {
    name: 'sector',
    title: i18n.t("sector").toUpperCase(),
    active: false,
    direction: false,
    value: 'sector',
  },
  country: {
    name: 'country',
    title: i18n.t("country").toUpperCase(),
    active: false,
    direction: false,
    value: 'country',
  },
  email: {
    name: 'email',
    title: i18n.t("email").toUpperCase(),
    active: false,
    direction: false,
    value: 'email',
  },
  phone: {
    name: 'phone',
    title: i18n.t("phone").toUpperCase(),
    active: false,
    direction: false,
    value: 'phone',
  },
}

export default headers;